/**
 * The Day timeline's overview (user, 19/10/2026: "the main view is the
 * numbers and the containers — the lists in use must be one button that
 * expands"): the summary, then "The day" and "Lists in use today", each
 * folded into one button.
 * The "Lists in use" tile opens the same panel and brings it into view, so
 * both say the same thing and stay in step.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, useRef, useState } from 'react';

import type { DayPlanPreview } from '../../../drop-generator.types';
import { DayChart } from '../day/DayChart';
import { ListsInUse } from '../lists/ListsInUse';
import { TimelineSummary } from './TimelineSummary';

export const DayOverview: FC<{ preview: DayPlanPreview }> = ({ preview }) => {
  const [open, setOpen] = useState(false);
  const panel = useRef<HTMLDivElement>(null);
  const fromTile = () => {
    setOpen((was) => !was);
    if (!open) window.setTimeout(() => panel.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 120);
  };
  return (
    <>
      <TimelineSummary preview={preview} listsOpen={open} onLists={fromTile} />
      <DayChart preview={preview} />
      <div ref={panel} className="scroll-mt-4">
        <ListsInUse preview={preview} open={open} onToggle={() => setOpen((v) => !v)} />
      </div>
    </>
  );
};
